import axios from 'axios';

export const cancelTokenFromSignal = (signal?: AbortSignal) => {
  if (!signal) {
    return undefined;
  }

  const source = axios.CancelToken.source();

  const onAbort = () => source.cancel('aborted');

  if (signal.aborted) {
    onAbort();
  } else {
    signal.addEventListener('abort', onAbort, { once: true });
  }

  return source;
};
